import { defineMessages } from 'react-intl'

const PROFILE_BODY_TYPE = {
  ECTOMORPH: 1,
  ECTO_MESOMORPH: 2,
  MESOMORPH: 3,
  MESO_ENDOMORPH: 4,
  ENDOMORPH: 5
}

const PROFILE_BODY_TYPES = Object.values(PROFILE_BODY_TYPE)

const labels = defineMessages({
  ectomorph: {
    id: 'ProfileBodyType.ectomorph',
    defaultMessage: 'Ectomorph',
    description: 'The label used for the ectomorph body type.'
  },
  ectoMesomorph: {
    id: 'ProfileBodyType.ectoMesomorph',
    defaultMessage: 'Ecto-Mesomorph',
    description: 'The label used for the ecto-mesomorph body type.'
  },
  mesomorph: {
    id: 'ProfileBodyType.mesomorph',
    defaultMessage: 'Mesomorph',
    description: 'The label used for the mesomorph body type.'
  },
  mesoEndomorph: {
    id: 'ProfileBodyType.mesoEndomorph',
    defaultMessage: 'Meso-Endomorph',
    description: 'The label used for the meso endomorph body type.'
  },
  endomorph: {
    id: 'ProfileBodyType.endomorph',
    defaultMessage: 'Endomorph',
    description: 'The label used for the endomorph body type.'
  }
})

const PROFILE_BODY_TYPE_MESSAGE = {
  [PROFILE_BODY_TYPE.ECTOMORPH]: labels.ectomorph,
  [PROFILE_BODY_TYPE.ECTO_MESOMORPH]: labels.ectoMesomorph,
  [PROFILE_BODY_TYPE.MESOMORPH]: labels.mesomorph,
  [PROFILE_BODY_TYPE.MESO_ENDOMORPH]: labels.mesoEndomorph,
  [PROFILE_BODY_TYPE.ENDOMORPH]: labels.endomorph
}

const shortLabels = defineMessages({
  ectomorphShort: {
    id: 'ProfileBodyType.ectomorphShort',
    defaultMessage: 'Ectomorph',
    description: 'The label used for the ectomorph body type.'
  },
  ectoMesomorphShort: {
    id: 'ProfileBodyType.ectoMesomorphShort',
    defaultMessage: 'Ecto-Meso',
    description: 'The label used for the ecto-mesomorph body type.'
  },
  mesomorphShort: {
    id: 'ProfileBodyType.mesomorphShort',
    defaultMessage: 'Mesomorph',
    description: 'The label used for the mesomorph body type.'
  },
  mesoEndomorphShort: {
    id: 'ProfileBodyType.mesoEndomorphShort',
    defaultMessage: 'Meso-Endo',
    description: 'The label used for the meso endomorph body type.'
  },
  endomorphShort: {
    id: 'ProfileBodyType.endomorphShort',
    defaultMessage: 'Endo',
    description: 'The label used for the endomorph body type.'
  }
})

const PROFILE_BODY_TYPE_SHORT_MESSAGE = {
  [PROFILE_BODY_TYPE.ECTOMORPH]: shortLabels.ectomorphShort,
  [PROFILE_BODY_TYPE.ECTO_MESOMORPH]: shortLabels.ectoMesomorphShort,
  [PROFILE_BODY_TYPE.MESOMORPH]: shortLabels.mesomorphShort,
  [PROFILE_BODY_TYPE.MESO_ENDOMORPH]: shortLabels.mesoEndomorphShort,
  [PROFILE_BODY_TYPE.ENDOMORPH]: shortLabels.endomorphShort
}

const helpers = defineMessages({
  ectomorphHelper: {
    id: 'ProfileBodyType.ectomorphHelper',
    defaultMessage: 'You tend to stay skinny no matter what you eat.',
    description: 'The second label used for the ectomorph body type.'
  },
  ectoMesomorphHelper: {
    id: 'ProfileBodyType.ectoMesomorphHelper',
    defaultMessage: 'You can build a decent amount of muscle but it is a slow process.',
    description: 'The second label used for the ecto-mesomorph body type.'
  },
  mesomorphHelper: {
    id: 'ProfileBodyType.advancedHelper',
    defaultMessage: 'You tend to stay lean and muscular without trouble gaining or losing weight.',
    description: 'The second label used for the mesomorph body type.'
  },
  mesoEndomorphHelper: {
    id: 'ProfileBodyType.mesoEndomorphHelper',
    defaultMessage: 'You can build muscle but you gain a noticable amount of fat with it.',
    description: 'The second label used for the meso-endomorph body type.'
  },
  endomorphHelper: {
    id: 'ProfileBodyType.expertHelper',
    defaultMessage: 'You tend to carry extra fat and it can be difficult to lose weight.',
    description: 'The second label used for the endomorph body type.'
  }
})

const PROFILE_BODY_TYPE_HELPER = {
  [PROFILE_BODY_TYPE.ECTOMORPH]: helpers.ectomorphHelper,
  [PROFILE_BODY_TYPE.ECTO_MESOMORPH]: helpers.ectoMesomorphHelper,
  [PROFILE_BODY_TYPE.MESOMORPH]: helpers.mesomorphHelper,
  [PROFILE_BODY_TYPE.MESO_ENDOMORPH]: helpers.mesoEndomorphHelper,
  [PROFILE_BODY_TYPE.ENDOMORPH]: helpers.endomorphHelper
}

export {
  PROFILE_BODY_TYPE,
  PROFILE_BODY_TYPES,
  PROFILE_BODY_TYPE_MESSAGE,
  PROFILE_BODY_TYPE_HELPER,
  PROFILE_BODY_TYPE_SHORT_MESSAGE
}
